<template>
  <tr>
    <td class="text-truncate" v-text="fss.rliss"></td>
    <td class="text-truncate" v-text="fss.agency_name"></td>
    <td class="text-truncate" v-text="fss.ag_status"></td>
    <td class="text-truncate" v-text="fss.plan_status"></td>
    <td :class="cntClass" v-html="usersWithLine"></td>
    <td style="text-align: center;" v-text="fss.saves"></td>
    <td style="text-align: center;" v-text="fss.last_update"></td>
  </tr>
</template>

<script>
export default {
  name: 'FssAccesRow',
  props: {
    fss: Object
  },
  computed: {
    cntClass() {
      return this.fss.usr_count==0 ? "table-danger" : "";
    },
    usersWithLine() {
      if(this.fss.users)
        return this.fss.users.replace(/,/g, "<br />");
      return "";
    }
  },
  methods: {

    percent(a, b) {
      if(b==0) return "n/a";
      return (100*a/b).toFixed(1) + "%";
    },
    remplis(a, b) {
      return a.toString() + "/" + b.toString();
    }
  }
}
</script>
<style>
progress {
  width: 100px;
}
</style>
